"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DictionarySettings = void 0;
const revision_1 = require("./revision");
class DictionarySettings {
    constructor(version, alphabetRule, revisions) {
        this.version = version;
        this.alphabetRule = alphabetRule;
        this.revisions = revisions;
    }
    static createEmpty() {
        const version = "";
        const alphabetRule = "";
        const revisions = new revision_1.Revisions();
        const settings = new DictionarySettings(version, alphabetRule, revisions);
        return settings;
    }
    static fromPlain(plain) {
        const version = plain.version;
        const alphabetRule = plain.alphabetRule;
        const revisions = revision_1.Revisions.fromPlain(plain.revisions);
        const settings = new DictionarySettings(version, alphabetRule, revisions);
        return settings;
    }
    toPlain() {
        const version = this.version;
        const alphabetRule = this.alphabetRule;
        const revisions = this.revisions.toPlain();
        return { version, alphabetRule, revisions };
    }
}
exports.DictionarySettings = DictionarySettings;
